import "./style.scss";
import ButtonSelector from "components/Secondary/ButtonSelector";
import StatisticsChart from "components/Secondary/StatisticsChart";
import StatsSection from "components/Secondary/StatsSection";
import { formatNumber } from "helpers/helpers";
import { useState, useEffect, useRef } from "react"
import AssetsTop from "../AssetsTop";
import AssetsList from "../AssetsList";
import { useSelector } from "react-redux";

const WalletsOverview = ({}) => {

  const container = useRef(null)

  const state = useSelector((state) => state.storage);
  const [searchSettings, setSearchSettings] = useState({
    searchValue: "",
    showZeroBalances: 1,
    showLowValueAssets: 1,
  });
  const [netWorth, setNetWorth] = useState(0);
  useEffect(() => {
    if (state.publicKey && state.accounts) {
      setNetWorth(state.accounts.reduce((sum, account) => sum += account.usdValue, 0));
    }
  }, [state.publicKey, state.accounts])

  useEffect(() => {
    container.current.scrollTo(0,0);
    
  }, [])

  const [historicalData, setHistoricalData] = useState([
    {price: 123, date: 1652932911000}, {price: 2, date: 1652932912000}, {price: 1234, date: 1652932913000},
  ]);

  return <div className="walletsOverview" >
    <div className="chartContainer" ref={container}>
      {/* <div className="switchersWrapper">
        <ButtonSelector items={[
              "Portfolio Chart", "Profit & Loss Chart"
            ]}
            selected={0}
          />
        <ButtonSelector items={[
            "24h", "7d", "30d"
          ]}
          selected={0}
        />
      </div> */}

      {/* <div className="chart">
        { historicalData &&
          <StatisticsChart chart={historicalData} xDataKey={"time"} yDataKey={"volume"}/>
        }
      </div> */}

      <StatsSection items={[
        {
          label: "Net Worth",
          value: "$" + formatNumber(netWorth, 2),
          description: "All Assets"
        },
        {
          label: "Trading Volume",
          value: "Coming Soon",// + formatNumber(10495942.34,2),
          description: "in 24 hours"
        },
        {
          label: "Fee Discounts",
          value: "Coming Soon",// + formatNumber(10495942.34,2),
          description: "All time",
          gain: true,
          //redirect: false"/wallets/fees"
        },
        {
          label: "Earned with Staking",
          value: "Coming Soon", // + formatNumber(10495942.34,2),
          description: "All time",
          gain: true,
          //redirect: false//() => "/wallets/fees"
        },
      ]}/>
      <div onClick={() => window.scrollTo(0,0)}>
        <AssetsTop title={"My Assets"} searchSettings={searchSettings} setSearchSettings={setSearchSettings}/>
        <AssetsList searchSettings={searchSettings}/>
      </div>
    </div>
  </div>
}

export default WalletsOverview;